// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface CalculateDrainagePatternOutput
 */
export interface CalculateDrainagePatternOutput {
  /**
   *
   */
  drainagePattern: RanaFile;
}

/**
 * Check if a given object implements the CalculateDrainagePatternOutput interface.
 */
export function instanceOfCalculateDrainagePatternOutput(
  value: object
): value is CalculateDrainagePatternOutput {
  if (
    (!("drainagePattern" in (value as Record<string, any>)) &&
      !("drainage_pattern" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["drainagePattern"] === undefined &&
      (value as Record<string, any>)["drainage_pattern"] === undefined)
  )
    return false;
  return true;
}

export function CalculateDrainagePatternOutputFromJSON(json: any): CalculateDrainagePatternOutput {
  return CalculateDrainagePatternOutputFromJSONTyped(json, false);
}

export function CalculateDrainagePatternOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculateDrainagePatternOutput {
  if (json == null) {
    return json;
  }
  return {
    drainagePattern: RanaFileFromJSON(json["drainage_pattern"]),
  };
}

export function CalculateDrainagePatternOutputToJSON(json: any): CalculateDrainagePatternOutput {
  return CalculateDrainagePatternOutputToJSONTyped(json, false);
}

export function CalculateDrainagePatternOutputToJSONTyped(
  value?: CalculateDrainagePatternOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    drainage_pattern: RanaFileToJSON(value["drainagePattern"]),
  };
}
